import map from 'lodash/map';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import DatePicker from 'react-datepicker';
import './index.css';

const inputsList = {
  id: {
    tag: 'id',
    type: 'string',
  },
  from: {
    tag: 'from',
    type: 'string',
  },
  language: {
    tag: 'language',
    type: 'string',
  },
  email: {
    tag: 'email',
    type: 'string',
  },
  firstName: {
    tag: 'firstName',
    type: 'string',
  },
  mainFavoriteClubNumber: {
    tag: 'mainFavoriteClubNumber',
    type: 'number',
  },
  mainFavoriteClubName: {
    tag: 'mainFavoriteClubName',
    type: 'string',
  },
  level: {
    tag: 'level',
    type: 'number',
  },
  country: {
    tag: 'country',
    type: 'string',
  },
  signedUpAt: {
    tag: 'signedUpAt',
    type: 'timestamp',
  },
  lastLoginAt: {
    tag: 'lastLoginAt',
    type: 'timestamp',
  },
  optinEmailNewsletter: {
    tag: 'optinEmailNewsletter',
    type: 'number',
  },
  optinEmailAlert: {
    tag: 'optinEmailAlert',
    type: 'number',
  },
  optinEmailFavoriteClub: {
    tag: 'optinEmailFavoriteClub',
    type: 'number',
  },
  optinEmailWall: {
    tag: 'optinEmailWall',
    type: 'number',
  },
  optinEmailScorer: {
    tag: 'optinEmailScorer',
    type: 'number',
  },
  optinPushNewsletter: {
    tag: 'optinPushNewsletter',
    type: 'number',
  },
  optinPushAlert: {
    tag: 'optinPushAlert',
    type: 'number',
  },
  optinPushScorer: {
    tag: 'optinPushScorer',
    type: 'number',
  },
  optinPushFavoriteClub: {
    tag: 'optinPushFavoriteClub',
    type: 'number',
  },
  optinPushWall: {
    tag: 'optinPushWall',
    type: 'number',
  },
  leagueMode1: {
    tag: 'leagueMode1',
    type: 'number',
  },
  leagueMode2: {
    tag: 'leagueMode2',
    type: 'number',
  },
  activeLeagues: {
    tag: 'activeLeagues',
    type: 'number',
  },
  activeLeaguesUK: {
    tag: 'activeLeaguesUK',
    type: 'number',
  },
  activeLeaguesES: {
    tag: 'activeLeaguesES',
    type: 'number',
  },
  activeLeaguesFR: {
    tag: 'activeLeaguesFR',
    type: 'number',
  },
  activeLeaguesFR2: {
    tag: 'activeLeaguesFR2',
    type: 'number',
  },
  activeLeaguesIT: {
    tag: 'activeLeaguesIT',
    type: 'number',
  },
  activeLeaguesEU: {
    tag: 'activeLeaguesEU',
    type: 'number',
  },
  hadActiveLeagues: {
    tag: 'hadActiveLeagues',
    type: 'number',
  },
  leaguesQuantity: {
    tag: 'leaguesQuantity',
    type: 'number',
  },
  activeLeaguesQuantity: {
    tag: 'activeLeaguesQuantity',
    type: 'number',
  },
  leagueCreatorQuantity: {
    tag: 'leagueCreatorQuantity',
    type: 'number',
  },
  leagueJoinerQuantity: {
    tag: 'leagueJoinerQuantity',
    type: 'number',
  },
  activeLeagueCreatorQuantity: {
    tag: 'activeLeagueCreatorQuantity',
    type: 'number',
  },
  activeLeagueJoinerQuantity: {
    tag: 'activeLeagueJoinerQuantity',
    type: 'number',
  },
  hasBeenExpertCurrentSeason: {
    tag: 'hasBeenExpertCurrentSeason',
    type: 'number',
  },
  hasBeenExpert: {
    tag: 'hasBeenExpert',
    type: 'number',
  },
  purchasedExpertCurrentSeason: {
    tag: 'purchasedExpertCurrentSeason',
    type: 'number',
  },
  purchasedExpert: {
    tag: 'purchasedExpert',
    type: 'number',
  },
  paidAmountCurrentSeason: {
    tag: 'paidAmountCurrentSeason',
    type: 'number',
  },
  paidAmountSince2018: {
    tag: 'paidAmountSince2018',
    type: 'number',
  },
  hasToken: {
    tag: 'hasToken',
    type: 'number',
  },
  lastAppVersion: {
    tag: 'lastAppVersion',
    type: 'number',
  },
  higherState: {
    tag: 'higherState',
    type: 'number',
  },
};

class TargetingQueries extends React.Component {
  renderQuery = (value, key) => {
    const {onChange, onDelete, onAdd, onChangeOperator} = this.props;
    return (
      <div
        style={{
          position: 'relative',
          border: '1px solid #4a4a4a',
          borderRadius: 10,
          margin: '30px 15px',
          width: '100%',
          padding: 20,
          backgroundColor: '#f5f6f8',
        }}
        key={key}>
        {value.operator && (
          <div
            style={{
              border: '1px solid #4a4a4a',
              position: 'absolute',
              borderTopRightRadius: 10,
              borderTopLeftRadius: 10,
              width: 50,
              borderBottom: '1px solid #f5f6f8',
              textAlign: 'center',
              marginTop: -42,
              cursor: 'pointer',
              backgroundColor: value.operator === 'OR' ? 'red' : '#45c945',
              color: 'white',
              fontWeight: 'bold',
            }}
            onClick={() => onChangeOperator(key)}>
            {value.operator}
          </div>
        )}
        {value.type !== 'field' && (
          <div
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
            }}
            onClick={() => onDelete(key)}>
            <i
              style={{
                color: 'red',
                fontSize: 16,
                cursor: 'pointer',
                margin: 10,
              }}
              className="fa fa-trash-o"
            />
          </div>
        )}
        {value.type === 'field' ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            className="fieldContainer">
            <select
              style={{flex: 2}}
              className="form-control"
              value={value.name}
              onChange={event => {
                onChange(event.target.value, `${key}.name`);
                onChange(
                  inputsList[event.target.value].type,
                  `${key}.fieldType`,
                );
                if (value.fieldType === 'timestamp') {
                  onChange('greater', `${key}.operation`);
                  onChange(moment().utc().format(), `${key}.parameter`);
                }
              }}>
              {map(inputsList, ({tag}, key) => (
                <option key={key} value={tag}>
                  {tag}
                </option>
              ))}
            </select>
            <select
              className="form-control"
              style={{flex: 1, margin: '0 20px'}}
              value={value.operation}
              onChange={event =>
                onChange(event.target.value, `${key}.operation`)
              }>
              {value.fieldType !== 'timestamp' && (
                <option value="equal">=</option>
              )}
              {value.fieldType !== 'timestamp' && (
                <option value="different">!=</option>
              )}
              {value.fieldType !== 'string' && (
                <option value="greater">{'>'}</option>
              )}
              {value.fieldType !== 'string' && (
                <option value="lower">{'<'}</option>
              )}
            </select>
            <div style={{flex: 2}}>
              {inputsList[value.name]?.type === 'timestamp' ? (
                <DatePicker
                  className="inputDatePicker"
                  selected={new Date(value.parameter)}
                  onChange={date =>
                    onChange(moment(date).utc().format(), `${key}.parameter`)
                  }
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="d/M/yyyy hh:mm aa"
                  timeCaption="time"
                />
              ) : (
                <input
                  style={{width: '200px'}}
                  type={inputsList[value.name].type}
                  className="form-control"
                  value={value.parameter}
                  onChange={event =>
                    onChange(event.target.value, `${key}.parameter`)
                  }
                />
              )}
            </div>
            <div style={{flex: 1}}>
              <i
                style={{
                  color: 'red',
                  fontSize: 16,
                  cursor: 'pointer',
                  margin: 10,
                }}
                className="fa fa-trash-o"
                onClick={() => onDelete(key)}
              />
            </div>
          </div>
        ) : (
          <div>
            {map(value.fields, (i, j) =>
              this.renderQuery(i, `${key}.fields.${j}`),
            )}
          </div>
        )}
        <i
          style={{fontSize: 22, color: '#45c945', cursor: 'pointer'}}
          className="fa fa-plus-circle addIcon"
          onClick={() => onAdd(key)}
        />
      </div>
    );
  };

  render() {
    const {data} = this.props;
    return <>{map(data, this.renderQuery)}</>;
  }
}

TargetingQueries.propTypes = {
  data: PropTypes.string.isRequired,
};

TargetingQueries.defaultProps = {
  data: {},
};

export default TargetingQueries;



// WEBPACK FOOTER //
// ./src/components/TargetingQueries/index.js